import { render, staticRenderFns } from "./CreatorProfileVosges.vue?vue&type=template&id=26c23142&scoped=true&"
import script from "./CreatorProfileVosges.vue?vue&type=script&lang=js&"
export * from "./CreatorProfileVosges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c23142",
  null
  
)

export default component.exports